import { failureAction, requestAction, successAction } from '../actions';

export const wrapThunkWithLifecycle = (key, thunk, context) => (
  ...args
) => async (dispatch) => {
  dispatch(requestAction(key));
  try {
    const boundThunk = thunk.bind(context);
    const funcToDispatch = boundThunk(...args);

    const success = await dispatch(funcToDispatch);

    dispatch(successAction(key, success));

    return success;
  } catch (error) {
    dispatch(failureAction(key, error));

    return Promise.reject(error);
  }
};
